<template>
  <b-modal
    v-model="isOpen"
    title="Gerenciar Tipos de Item"
    size="lg"
    hide-footer
    centered
    @hidden="onClose"
  >
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <input
            type="text"
            class="form-control"
            v-model="newTypeName"
            placeholder="Nome do novo tipo..."
            @keyup.enter="addType"
          />
        </div>
        <div class="col-auto">
          <button
            class="btn btn-primary"
            @click="addType"
            :disabled="!newTypeName.trim() || saving"
          >
            <i class="bx bx-plus"></i> Adicionar
          </button>
        </div>
      </div>
    </div>

    <div v-if="loading" class="text-center py-4">
      <b-spinner variant="primary" small></b-spinner>
      <span class="ms-2">Carregando...</span>
    </div>

    <div v-else>
      <div v-if="itemTypes.length === 0" class="text-center py-4 text-muted">
        Nenhum tipo cadastrado
      </div>

      <table v-else class="table table-bordered">
        <thead>
          <tr>
            <th>Nome</th>
            <th width="100">Status</th>
            <th width="120">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="itemType in itemTypes" :key="itemType.id">
            <td>
              <input
                v-if="editingId === itemType.id"
                type="text"
                class="form-control form-control-sm"
                v-model="editingName"
                @keyup.enter="saveEdit(itemType)"
                @keyup.esc="cancelEdit"
              />
              <span v-else>{{ itemType.name }}</span>
            </td>
            <td class="text-center">
              <span
                class="badge"
                :class="itemType.is_active ? 'badge-success' : 'badge-secondary'"
              >
                {{ itemType.is_active ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
            <td>
              <div class="d-flex gap-1">
                <template v-if="editingId === itemType.id">
                  <button
                    class="btn btn-sm btn-success"
                    @click="saveEdit(itemType)"
                    :disabled="saving"
                  >
                    <i class="bx bx-check"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-secondary"
                    @click="cancelEdit"
                  >
                    <i class="bx bx-x"></i>
                  </button>
                </template>
                <template v-else>
                  <button
                    class="btn btn-sm btn-outline-primary"
                    @click="startEdit(itemType)"
                    title="Editar"
                  >
                    <i class="bx bx-edit"></i>
                  </button>
                  <button
                    class="btn btn-sm"
                    :class="itemType.is_active ? 'btn-outline-warning' : 'btn-outline-success'"
                    @click="toggleActive(itemType)"
                    :title="itemType.is_active ? 'Desativar' : 'Ativar'"
                  >
                    <i :class="itemType.is_active ? 'bx bx-hide' : 'bx bx-show'"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-outline-danger"
                    @click="confirmDelete(itemType)"
                    title="Excluir"
                  >
                    <i class="bx bx-trash"></i>
                  </button>
                </template>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>

<script>
import {
  fetchItemTypes,
  createItemType,
  updateItemType,
  deleteItemType
} from '@/modules/storage/service/storageService'
import { successMessage, errorMessage, confirmAction } from '@/components/alertsMessages'

export default {
  name: 'ItemTypesModal',
  data: function () {
    return {
      isOpen: false,
      loading: false,
      saving: false,
      itemTypes: [],
      newTypeName: '',
      editingId: null,
      editingName: ''
    }
  },
  methods: {
    open: function () {
      this.isOpen = true
      this.loadItemTypes()
    },
    close: function () {
      this.isOpen = false
    },
    onClose: function () {
      this.editingId = null
      this.editingName = ''
      this.newTypeName = ''
    },
    loadItemTypes: function () {
      var self = this
      self.loading = true

      fetchItemTypes()
        .then(function (response) {
          self.loading = false
          self.itemTypes = response.data || response
        })
        .catch(function (error) {
          self.loading = false
          console.error('Erro ao carregar tipos:', error)
          errorMessage('Erro ao carregar tipos')
        })
    },
    addType: function () {
      var self = this
      var name = self.newTypeName.trim()

      if (!name) return

      self.saving = true

      createItemType({ name: name, is_active: true })
        .then(function () {
          self.saving = false
          self.newTypeName = ''
          self.loadItemTypes()
          successMessage('Tipo adicionado com sucesso')
        })
        .catch(function (error) {
          self.saving = false
          console.error('Erro ao criar tipo:', error)
          errorMessage('Erro ao criar tipo')
        })
    },
    startEdit: function (itemType) {
      this.editingId = itemType.id
      this.editingName = itemType.name
    },
    cancelEdit: function () {
      this.editingId = null
      this.editingName = ''
    },
    saveEdit: function (itemType) {
      var self = this
      var name = self.editingName.trim()

      if (!name) return

      self.saving = true

      updateItemType(itemType.id, { name: name })
        .then(function () {
          self.saving = false
          self.editingId = null
          self.editingName = ''
          self.loadItemTypes()
          successMessage('Tipo atualizado com sucesso')
        })
        .catch(function (error) {
          self.saving = false
          console.error('Erro ao atualizar tipo:', error)
          errorMessage('Erro ao atualizar tipo')
        })
    },
    toggleActive: function (itemType) {
      var self = this

      updateItemType(itemType.id, { name: itemType.name, is_active: !itemType.is_active })
        .then(function () {
          self.loadItemTypes()
          successMessage(itemType.is_active ? 'Tipo desativado' : 'Tipo ativado')
        })
        .catch(function (error) {
          console.error('Erro ao atualizar tipo:', error)
          errorMessage('Erro ao atualizar tipo')
        })
    },
    confirmDelete: function (itemType) {
      var self = this

      confirmAction('Excluir Tipo', 'Tem certeza que deseja excluir o tipo "' + itemType.name + '"?')
        .then(function (confirmed) {
          if (confirmed) {
            self.deleteType(itemType)
          }
        })
    },
    deleteType: function (itemType) {
      var self = this

      deleteItemType(itemType.id)
        .then(function () {
          self.loadItemTypes()
          successMessage('Tipo excluído com sucesso')
        })
        .catch(function (error) {
          console.error('Erro ao excluir tipo:', error)
          errorMessage('Erro ao excluir tipo. Verifique se não há itens associados.')
        })
    }
  }
}
</script>

<style scoped>
.gap-1 {
  gap: 0.25rem;
}
</style>
